export const RTL_SCROLL_SELECTOR = [
  '.sec2_cards_holder',
  '.product-category-options',
  '.product-category-track',
  '.related-products-grid',
].join(', ');

export function alignHorizontalScrollContainers(language, root = document) {
  const isArabic = language === 'ar';

  root.querySelectorAll(RTL_SCROLL_SELECTOR).forEach((container) => {
    container.scrollLeft = isArabic ? container.scrollWidth : 0;
  });
}
